import client from "./axiosConfig";

export const postSite = (data) => {
  const config = {
    url: "/projects/sites/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const deleteTask = (data) => {
  const config = {
    url: "/tasks/manage-task/",
    method: "DELETE",
    data
  };
  const response = client(config);
  return response;
};

export const bulkDeleteTasks = (data) => {
  const config = {
    url: "/tasks/site-task/bulk_delete/",
    method: "DELETE",
    data,
  };
  return client(config);
};

export const deleteTaskById = (taskId) => {
  const config = {
    url: `/tasks/site-task/${taskId}/`,
    method: "DELETE",
  };
  const response = client(config);
  return response;
};

export const manageTask = (data) => {
  const config = {
    url: "/tasks/manage-task/",
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const getTaskById = (taskId) => {
  const config = {
    url: `/tasks/site-task/${taskId}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const getAllTasks = (params) => {
  const config = {
    url: "/tasks/site-task/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const postTask = (data) => {
  const config = {
    url: `/tasks/site-task/`,
    method: "POST",
    data
  };
  const response = client(config);
  return response;
};

export const postCreatedFromMasterTask = (data) => {
  const config = {
    url: `/tasks/site-task/create_from_master/`,
    method: "POST",
    data
  };
  const response = client(config);
  return response;
};

export const patchTaskById = (taskId, data) => {
  const config = {
    url: `/tasks/site-task/${taskId}/`,
    method: "PATCH",
    data
  };
  const response = client(config);
  return response;
};

export const getSites = (params) => {
  const config = {
    url: "/projects/sites/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getSiteTasks = (site_id, params) => {
  const config = {
    url: `/tasks/site-task/?site=${site_id}`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getTasksSummary = () => {
  const config = {
    url: `/tasks/summary/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const getMasterTask = (params) => {
  const config = {
    url: `/tasks/master/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getMasterTaskById = (taskId, params) => {
  const config = {
    url: `/tasks/master/${taskId}/subtask/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const fetchComments = (taskId, params) => {
  const config = {
    url: `/tasks/site-task/${taskId}/comments/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const postComment = (taskId, data) => {
  const config = {
    url: `/tasks/site-task/${taskId}/comments/`,
    method: "POST",
    data
  };
  const response = client(config);
  return response;
};

export const taskAction = (taskId, data) => {
  const config = {
    url: `/tasks/site-task/${taskId}/review/`,
    method: "PATCH",
    data
  };
  const response = client(config);
  return response;
};

export const getTaskFiles = ( taskId, params ) => {
  const config = {
    url: `/tasks/site-task/${taskId}/files/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
}

export const deleteTaskFiles = ( taskId, fileId) => {
  const config = {
    url: `/tasks/site-task/${taskId}/files/${fileId}/`,
    method: "DELETE",
  };
  const response = client(config);
  return response;
}

export const postTaskFiles = (taskId, data) => {
  const config = {
    url: `/tasks/site-task/${taskId}/files/`,
    method: "POST",
    data
  };
  const response = client(config);
  return response;
}

export const getSiteDetailsById = (site_id, params) => {
  const config = {
    url: `/projects/sites/${site_id}/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const updateSiteDetails = (id, data) => {
  const config = {
    url: `/projects/sites/${id}/`,
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const getSiteUsers = (siteId, params = {}) => {
  const config = {
    url: `/projects/sites/${siteId}/users/`,
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const uploadSiteUsers = (siteId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const config = {
    url: `/projects/sites/${siteId}/site-users-excel/`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const response = client(config);
  return response;
};

export const deleteSiteUser = (siteId, userId) => {
  const config = {
    url: `/projects/sites/${siteId}/users/${userId}/`,
    method: "DELETE",
  };
  const response = client(config);
  return response;
};

export const updateSiteUser = (siteId, userId, data) => {
  const config = {
    url: `/projects/sites/${siteId}/users/${userId}/`,
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const getSiteFiles = (siteId, params) => {
  const config = {
    url: `/projects/sites/${siteId}/files/`,
    method: "GET",
    params,
  };
  return client(config);
};

export const uploadSiteFile = (siteId, data) => {
  const config = {
    url: `/projects/sites/${siteId}/files/`,
    method: "POST",
    data,
  };
  return client(config);
};

export const deleteSiteFile = (siteId, fileId) => {
  const config = {
    url: `/projects/sites/${siteId}/files/${fileId}/`,
    method: "DELETE",
  };
  return client(config);
};

export const addSiteUser = (siteId, data) => {
  const config = {
    url: `/projects/sites/${siteId}/users/`,
    method: "POST",
    data
  };
  return client(config);
}

export const bulkDeleteSiteUsers = (siteId, userIds) => {
  const config = {
    url: `/projects/sites/${siteId}/users/bulk-remove/`,
    method: "DELETE",
    data: { ids: userIds },
  };
  return client(config);  
};